// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--W3lps","BodyContainerText":"_BodyContainerText--MniHe","WarningIcon":"_WarningIcon--_UfY6"};